import { SortDirection } from '../../../../enums/SortDirection';

export const sortingOrderInverse = [SortDirection.Desc, SortDirection.Asc, null];
